import React from 'react';
import { companyInfo, whatsappNumber, whatsappMessage } from '../../data/mock';
import { MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" style={{ padding: '2.5rem 2rem 1.5rem' }}>
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-6">
          {/* Brand Column - Left */}
          <div className="max-w-sm">
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              style={{ width: '180px', height: 'auto' }}
              className="object-contain mb-3"
            />
            <p className="text-white/70 leading-relaxed text-sm">
              Automação de atendimento para médicos. Transforme o atendimento do seu consultório com inteligência artificial humanizada.
            </p>
          </div>

          {/* Right side columns */}
          <div className="flex gap-16 md:gap-20">
            {/* Links Column */}
            <div>
              <h4 className="font-semibold text-white mb-3 text-sm">Links Rápidos</h4>
              <nav className="space-y-2">
                <button 
                  onClick={() => scrollToSection('beneficios')}
                  className="block text-white/70 hover:text-white transition-colors text-sm"
                >
                  Benefícios
                </button>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="block text-white/70 hover:text-white transition-colors text-sm"
                >
                  FAQ
                </button>
              </nav>
            </div>

            {/* Contact Column */}
            <div>
              <h4 className="font-semibold text-white mb-3 text-sm">Contato</h4>
              <div className="space-y-3">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-whatsapp text-sm py-2 px-4"
                >
                  Falar no WhatsApp
                </a>
                <div className="flex items-center gap-2 text-white/70 text-sm">
                  <MapPin size={14} className="flex-shrink-0" />
                  <span>São Paulo, SP - Brasil</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar - Copyright only */}
        <div className="border-t border-white/10 pt-4">
          <p className="text-white/50 text-sm">
            © {currentYear} {companyInfo.name}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
